import React from "react";
import CardContent from '@material-ui/core/CardContent';
import ActionModel from "../../../../../models/ActionModel/ActionModel";
import AppSearch from "../../NewAction/inputs/AppsInput/appSearch";
import NewActionHeader from "../../NewAction/NewActionHeader/NewActionHeader";

class GooglePlayAction extends ActionModel {
	static metadata = {
		id: "googleplaystore",
		name: "Google Play",
		icon: "https://l.fast.cm/content/icons/googleplaystore.png",
		categories: {
			// apps: true,
		}
	};

	constructor(dat) {
		super();
		this.setFromObject(dat);
	}

	getConfigCardBody(cardModel, handleOnChangeIcon) {
		return (
			<CardContent>
				<NewActionHeader
					onChangeIcon={handleOnChangeIcon}
					actionModel={this} />
				<AppSearch appPlatform={'Google'} cardModel={cardModel} actionModel={this} />
			</CardContent>
		)
	};
};

export default GooglePlayAction